import get from 'lodash/get'

import { useActiveBrand } from '@/core/store'
import globalStore from '@/store'

export const useCurrentTheme = {
  computed: {
    coreCurrentTheme() {
      const { mergedTheme: coreCurrentTheme } = useActiveBrand()
      return coreCurrentTheme.value
    },
    currentTheme() {
      const { brandThemePath, coreCurrentTheme, storeModule } = this

      if (brandThemePath) {
        return get(
          globalStore.getters[`${storeModule}/currentResource`],
          brandThemePath
        )
      } else {
        return coreCurrentTheme
      }
    },
  },
  inject: ['brandThemePath', 'storeModule'],
}
